import { catalogItemViewReducerPath } from './const';
import { CatalogItemViewReducerStateShape } from './types';

export const catalogItemViewListInstructionCompletedSelector = (state: CatalogItemViewReducerStateShape) =>
  state[catalogItemViewReducerPath].isListWithAssesmentInstructionCompleted;

export const catalogItemViewListInstructionCompletedByRegisteredUserSelector = (state: CatalogItemViewReducerStateShape) =>
  state[catalogItemViewReducerPath].isListWithAssesmentInstructionCompletedByRegisteredUser;
